<div style="padding: 8dvh;">
    <h2 class="mb-3"  mat-dialog-title><b>GRACIAS POR SU CONSULTA</b></h2>
    <mat-dialog-content style="width: 80%;">
      <p style="color: black;">Hemos recibido su consulta. La tramitaremos y le responderemos por emall en el plazo de una semana.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close [mat-dialog-close]="true" (click)="redirigir()" class="btn-dark">LO TENGO</button>
    </mat-dialog-actions>
  </div>